module.exports = __webpack_public_path__ + "img/视频场景视频会议.f4d500cc.png";